import { methods } from "../../utils/axios";

export default class PurchaseAPI {
  static createPaymentIntention(data) {
    return methods.post('/payments', data);
  }

  static getPaymentDetails(paymentId) {
    return methods.get(`/payments/${paymentId}`);
  }
}
